// extracted by mini-css-extract-plugin
module.exports = {"main":"Breeds_main__1ynMp","navigation":"Breeds_navigation__31NyW","container":"Breeds_container__2tKNZ"};